import { Button, Col, Row } from 'antd'
import { Variants, motion } from 'framer-motion'
import DetailRewardPopup from './DetailRewardPopup'

type Props = {}

const data = [
    {
        title: '01 Giải Nhất',
        prize: '5.000.000 VND'
    },
    {
        title: '01 Giải Nhì',
        prize: '3.000.000 VND'
    },
    {
        title: '01 Giải Ba',
        prize: '2.000.000 VND'
    },
    {
        title: '01 Giải Tiềm Năng',
        prize: '500.000 VND'
    },
    {
        title: '01 Giải Thí Sinh Được Yêu Thích Nhất',
        prize: '500.000 VND'
    }
]

const cardVariants: Variants = {
    offscreen: {
        fontSize: '0rem',
        y: 0
    },
    onscreen: {
        fontSize: window.innerWidth > 768 ? '3rem' : '2rem',
        y: -100,
        transition: {
            type: 'spring',
            stiffness: 200,
            damping: 20
        }
    }
}

const row1Variants: Variants = {
    offscreen: {
        opacity: 0,
        y: 60
    },
    onscreen: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            stiffness: 50,
            damping: 20
        }
    }
}

export default function Reward({}: Props) {
    return (
        <div
            style={{
                color: 'white',
                width: '100vw',
                marginTop: '30vh'
            }}
        >
            {/* title */}
            <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0.8 }}>
                <motion.div
                    variants={cardVariants}
                    style={{
                        fontFamily: 'conthrax',
                        textAlign: 'center'
                    }}
                >
                    {/* <div>TỔNG GIẢI THƯỞNG</div>
                    <div>12.000.000 VND</div> */}
                    <div>CƠ CẤU GIẢI THƯỞNG</div>
                    <div
                        style={{
                            fontSize: '.7rem',
                            fontWeight: 300,
                            marginTop: '.5rem',
                            fontFamily: 'Readex Pro'
                        }}
                    >
                        Tất cả giải thưởng đều bao gồm giấy chứng nhận bản cứng + bộ KIT kỷ niệm từ trường Đại học FPT + quà từ Nhà Tài Trợ
                    </div>
                    <div
                        style={{
                            textAlign: 'center'
                        }}
                    >
                        <DetailRewardPopup />
                    </div>
                </motion.div>
            </motion.div>
            <div
                style={{
                    fontFamily: 'Readex Pro',
                    textAlign: 'center',
                    width: window.innerWidth > 768 ? '50vw' : '90vw',
                    margin: 'auto',
                    fontSize: '.9rem',
                    fontWeight: 300
                }}
            >
                <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: false, amount: 0.8 }}>
                    <motion.div variants={row1Variants}>
                        <Row justify={'center'} gutter={[10, 10]}>
                            <Col span={8}>
                                <Card data={data[0]} />
                            </Col>
                            <Col span={8}>
                                <Card data={data[1]} />
                            </Col>
                            <Col span={8}>
                                <Card data={data[2]} />
                            </Col>
                        </Row>
                    </motion.div>
                </motion.div>
                <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: false, amount: 0.8 }}>
                    <motion.div variants={row1Variants}>
                        <Row justify={'center'} gutter={[10, 10]}>
                            <Col span={8}>
                                <Card data={data[3]} />
                            </Col>
                            <Col span={12}>
                                <Card data={data[4]} />
                            </Col>
                        </Row>
                    </motion.div>
                </motion.div>
            </div>
        </div>
    )
}

function Card({ data }: { data: any }) {
    return (
        <div
            style={{
                fontFamily: 'conthrax',
                textAlign: 'center',
                height: '10rem'
            }}
        >
            <div>{data.title}</div>
            <div>{data.prize}</div>
            <div>
                <img
                    src="v2/reward.png"
                    alt="reward"
                    style={{
                        width: '5rem',
                        height: 'auto',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    }}
                />
            </div>
        </div>
    )
}
